export default __webpack_public_path__ + "media/images/logo-symbol-icon-c24611a497d2c52f13cb6588e5c14392.svg";